import { ListChecksIcon } from '@phosphor-icons/react';
import type { WorkbookDefinition } from '@erp/shared-types';
import type { OutlineNode } from '@erp/workbooks';
import { WorkbookItemIcon } from './workbookItemIcon';
import { workbookItemIconKind } from './workbookItemIconKind';

/** An Outline node's icon: its Item's, or a checklist for an Instruction. */
export function WorkbookExecutionIcon({
  node,
  definition,
}: {
  node: OutlineNode;
  definition: Pick<
    WorkbookDefinition,
    'files' | 'sources' | 'sheets' | 'outputs'
  >;
}) {
  const className = 'size-4 shrink-0 text-muted-foreground';
  if (node.kind === 'instruction')
    return <ListChecksIcon className={className} aria-hidden />;
  return (
    <WorkbookItemIcon
      kind={
        // A removed Worksheet's root keeps the Worksheet icon.
        workbookItemIconKind(definition, node.itemId) ?? 'worksheet'
      }
      className={className}
      aria-hidden
    />
  );
}
